import { useCallback } from 'react';
import { Actions } from '../actions/enums';
import { useCartMergeListener } from './useCart';
import { UnifiedAuthState } from './unifiedAuth/authStateTransitions';

export type CartMergeStatus = 'idle' | 'merged' | 'failed' | 'did-nothing';

// Consolidated cart merge hook: subscribes to cart merge events and applies auth transitions.
// Provides the latest merge status and a reset helper.
export const useCartMerge = (authState: UnifiedAuthState, setAuthState: (state: UnifiedAuthState) => void) => {
  const handleMerge = useCallback(
    (status: CartMergeStatus) => {
      if (authState.status !== 'Reminder' && authState.status !== 'ReminderMergeCheck') {
        return;
      }

      switch (status) {
        case 'idle':
          return;
        case 'merged':
        case 'failed':
          setAuthState({ status: 'Closed' });
          return;
        case 'did-nothing':
          globalThis.ikea.pubsub.publish(Actions.GO_TO_CHECKOUT);
          return;
        default:
          status satisfies never;
          globalThis.ikea.pubsub.publish(Actions.GO_TO_CHECKOUT);
      }
    },
    [authState.status, setAuthState],
  );

  useCartMergeListener(handleMerge);
};
